import React, { useCallback } from 'react';
import { Box, Text, Flex, Button, Switch, Spacer } from '@chakra-ui/react';

const SlidingCard = ({ item, onDelete, onEdit, onFav, onEnableDisable, onView, onToggleActive }) => {

  const {
    item_type = '',
    url = null,
    sort_order = 0,
    is_active = false,
    created_at = '',
    updated_at = ''
  } = item || {};

  const handleToggleActive = useCallback(() => onToggleActive(item), [onToggleActive, item]);
  
  // console.log('item',item)
  const name = item_type?.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  return (
    <Box borderWidth="1px" borderRadius="lg" overflow="hidden" boxShadow="md" p={4} minW={180} minH={100}>
      <Text fontWeight="bold">{name}</Text>
      <Text>{item.description}</Text>
      <Spacer></Spacer>

      <Flex mt={6} justify="space-between" align="center">
      {/* <IconButton icon={<StarIcon />} onClick={() => onFav(item)} aria-label="Favorite" />
      <IconButton icon={<ViewIcon />} onClick={() => onView(item)} aria-label="View" />
      <IconButton icon={item.enabled ? <CloseIcon /> : <CheckIcon />} onClick={() => onEnableDisable(item)} aria-label="Enable/Disable" />
      <Button onClick={() => onEdit(item)} size="sm">Edit</Button> */}
      {/* <Button onClick={() => onDelete(item)} size="sm" colorScheme="red">Delete</Button> */}
      {/* <Spacer></Spacer> */}
      <Switch isChecked={item.is_active} onChange={handleToggleActive} />
      {/* <IconButton key={item.item_type} icon={item.is_active ? <CloseIcon /> : <CheckIcon />} onClick={() => handleToggleActive(item)} aria-label="Enable/Disable" /> */}
    </Flex>
    </Box>
  );
};

export default SlidingCard;
